import { normalizeAddress } from "@/lib/utils/address";

/** Polygon chain ID */
export const POLYGON_CHAIN_ID = 137;

export const POLYGON_USDC_ADDRESS = "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359";

export const POLYGON_PUSD_ADDRESS = "0xC011a7E12a19f7B1f670d46F03B03f3342E82DFB";
export const POLYGON_PUSD_ADDRESS_LOWER = POLYGON_PUSD_ADDRESS.toLowerCase();
export const POLYGON_PUSD_ADDRESS_NORMALIZED = normalizeAddress(POLYGON_PUSD_ADDRESS);

export const POLYGON_NATIVE_ADDRESS = "0x0000000000000000000000000000000000000000";

export const POLYMARKET_ICON_URL = "https://cdn.b3.fun/b3os-icons/polymarket-icon.png";

/**
 * Default payload for the polymarket-get-positions action. Shared so the
 * tab and combined-positions surfaces produce the same TanStack cache key.
 */
export const POLYMARKET_POSITIONS_PAYLOAD = {
  sortBy: "CURRENT",
  sortDirection: "DESC",
  sizeThreshold: 0.01,
  limit: 100,
} as const;
